import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "../../utlils/axios";
import { dispatch } from "../index"
import { handleSnackbar } from "../../utlils/snackbar";

// Type for each field inside fieldsList
interface Field {
  fieldCode: string | null;
  fieldLabel: string | null;
  fieldDesc: string | null;
  inputField: boolean;
  fieldDataType: string | null;
  maxLength: string | null;
  validationRegEx: string | null;
  validationMessage: string | null;
  fieldExpression: string | null;
  displayOrder: number | string;
  defaultValue: string | null;
  required: boolean;
  fieldValue: string | null;
  fieldGroupCode: string | null;
}

// Type for the outer object
export interface FieldGroup {
  fieldGroupLabel: string | null;
  fieldGroupInput: boolean;
  fieldGroupOrder: number | string;
  fieldsList: Field[];
}

interface fieldDataPayload {
  [key: string]: string;
}

type logDataSystemDateState = string


export interface StateValues {
  initialFieldState: FieldGroup[]
  addFieldData: {};
  getFieldData: fieldDataPayload[]
  getSingleFieldData: FieldGroup[]
  updateFieldDate: {};
  computeFieldData: {};
  exportLogData: {};
  logDataSystemDate: logDataSystemDateState;
  loading: boolean;
}

const initialState: StateValues = {
  initialFieldState: [],
  addFieldData: {},
  getFieldData: [],
  getSingleFieldData: [],
  updateFieldDate: {},
  computeFieldData: {},
  exportLogData: {},
  logDataSystemDate: "",
  loading: false
};

const fieldSlice = createSlice({
  name: "fieldSlice",
  initialState,
  reducers: {
    getFieldListLabels(state, action) {
      state.initialFieldState = action.payload;
    },
    addFieldDataValue(state, action) {
      state.addFieldData = action.payload
    },
    getFieldDataList(state, action) {
      state.getFieldData = action.payload
    },
    getSingleFieldDataValue(state, action) {
      state.getSingleFieldData = action.payload
    },
    updateFieldDataValue(state, action) {
      state.updateFieldDate = action.payload
    },
    getComputedDataValue(state, action) {
      state.computeFieldData = action.payload
    },
    getExportLogDataValue(state, action) {
      state.exportLogData = action.payload
    },
    getLogDataSystemDateValue(state, action) {
      state.logDataSystemDate = action.payload
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  }
});

export default fieldSlice.reducer;

export const { setLoading } = fieldSlice.actions


// Get Field List Value
export const getFieldList = (modelCode: string) => {
  return async () => {
    const url = `/de/field-list/${modelCode}`
    try {
      const response = await axios.get(url)
      dispatch(fieldSlice.actions.getFieldListLabels(response.data))
    } catch (error) {
      dispatch(handleSnackbar(error));
    }
  }
}

// Get Log Data System Date Value
export const getLogDataSystemDate = () => {
  return async () => {
    const url = "/de/system-date"
    try {
      const response = await axios.get(url)
      dispatch(fieldSlice.actions.getLogDataSystemDateValue(response.data))
    } catch (error) {
      dispatch(handleSnackbar(error));
    }
  }
}

// Get Export Log Data Value
export const getExportLogData = (fromDate: string, toDate: string) => {
  return async () => {
    const url = `/de/export-log-data/${fromDate}/${toDate}`
    try {
      const response = await axios.get(url)
      dispatch(fieldSlice.actions.getExportLogDataValue(response.data))
      return response
    } catch (error) {
      dispatch(handleSnackbar(error));
    }
  }
}

//Add Post Data
export const addLogData = (logDate: string, payload: fieldDataPayload, modelCode: string) => {
  return async () => {
    const url = `/de/${logDate}/${modelCode}`
    try {
      const response = await axios.post(url, payload)
      dispatch(fieldSlice.actions.addFieldDataValue(response.data))
      dispatch(handleSnackbar(response?.data))
      return response
    } catch (error: any) {
      return error
    }
  }
}

// Get Log Data List
export const getLogDataList = (modelCode: string) => {
  return async () => {
    dispatch(setLoading(true));
    const url = `/de/log-data-list/${modelCode}`
    try {
      const response = await axios.get(url)
      dispatch(fieldSlice.actions.getFieldDataList(response.data))
      return response
    } catch (error) {
      dispatch(handleSnackbar(error));
    } finally {
      dispatch(setLoading(false));
    }
  }
}

// Get Single Log Data
export const getSingleLogDataValues = (logDate: string | number, modelCode: string) => {
  return async () => {
    const url = `/de/field-data/${logDate}/${modelCode}`
    try {
      const response = await axios.get(url)
      dispatch(fieldSlice.actions.getSingleFieldDataValue(response.data))
    } catch (error) {
      console.log("error", error)
      dispatch(handleSnackbar(error));
    }
  }
}

// Update Log Data
export const updateLogData = (logDate: string, payload: fieldDataPayload, modelCode: string) => {
  return async () => {
    const url = `/de/${logDate}/${modelCode}`
    try {
      const response = await axios.put(url, payload)
      dispatch(fieldSlice.actions.updateFieldDataValue(response.data))
      dispatch(handleSnackbar(response?.data))
      return response
    } catch (error) {
      // dispatch(handleSnackbar(error));
      return error
    }
  }
}

// Get Computed Data
export const getComputedData = (logDate: string, payload: fieldDataPayload, modelCode: string) => {
  return async () => {
    const url = `/de/get-eval-fields-value/${logDate}/${modelCode}`
    try {
      const response = await axios.post(url, payload)
      dispatch(fieldSlice.actions.getComputedDataValue(response.data))
      return response
    } catch (error) {
      dispatch(handleSnackbar(error));
    }
  }
}



